import styled from "styled-components";

import { color } from "../../theme/color";

/** The settings on a page, in groups below each other. */
export const SettingsBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 28px;
    padding: 8px 16px 32px;
    max-width: 480px;
`;

/** A group of settings that belong together, under a small heading. */
export const SettingsGroup = styled.section`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

/** Text under a setting that explains it. */
export const SettingNote = styled.p`
    margin: -4px 0 0;
    font-size: 13px;
    line-height: 18px;
    color: ${color.textMuted};
`;
